module.exports = __webpack_public_path__ + "static/media/portfolio5.0c9e07f5.png";